
export enum Chain {
    MAINNET = "0xb880D47D3894D99157B52A7F869aB3B1E2D4349d",
    SEPOLIA = "0xe75af5294f4CB4a8423ef8260595a54298c7a2FB",
    OPTIMISM = "0xC3287BDEF03b925A7C7f54791EDADCD88e632CcD",
    OPTIMISM_SEPOLIA = "0x3c8Cd1714AC9c380702D160BE4cee0D291Eb89C0",
    ARBITRUM = "0xC20DeDbE8642b77EfDb4372915947c87b7a526bD",
    ARBITRUM_SEPOLIA = "0xC3287BDEF03b925A7C7f54791EDADCD88e632CcD",
    MANTA = "0xBC24514E541d5CBAAC1DD155187A171a593e5CF6",
    MANTA_SEPOLIA = "0xC20DeDbE8642b77EfDb4372915947c87b7a526bD",
    LINEA = "0xC20DeDbE8642b77EfDb4372915947c87b7a526bD",
    BASE = "0xC20DeDbE8642b77EfDb4372915947c87b7a526bD",
    POLYGON = "0xC20DeDbE8642b77EfDb4372915947c87b7a526bD"
}

export enum SimplePromptAddresses {
    MAINNET = "0x61423153f111BCFB28dd264aBA8d9b5C452228D2",
    SEPOLIA = "0x696c83111a49eBb94267ecf4DDF6E220D5A80129",
    OPTIMISM = "0xBC24514E541d5CBAAC1DD155187A171a593e5CF6",
    OPTIMISM_SEPOLIA = "0xf6919ebb1bFdD282c4edc386bFE3Dea1a1D8AC16",
    ARBITRUM = "0xC3287BDEF03b925A7C7f54791EDADCD88e632CcD",
    ARBITRUM_SEPOLIA = "0xBC24514E541d5CBAAC1DD155187A171a593e5CF6",
    MANTA = "0x523622DfEd0243B0DF80CC9275764B0f432D33E3",
    MANTA_SEPOLIA = "0x3bfD1Cc919bfeC7795b600E764aDa001b58f122a",
    LINEA = "0xb880D47D3894D99157B52A7F869aB3B1E2D4349d",
    BASE = "0xC3287BDEF03b925A7C7f54791EDADCD88e632CcD",
    POLYGON = "0xC3287BDEF03b925A7C7f54791EDADCD88e632CcD"
}

export enum Models {
    STABLE_DIFFUSION = 50,
    LLAMA2 = 11,
    OPENLM = 13
}